module.exports = __webpack_public_path__ + "a791c6d033c20e4bccdf1b77652181c0.svg";